import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Cta from "../../components/Cta/Cta"; 

const RealizzazioneDettaglio = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    fetch(`http://dev18.makemedia.it/wp/wp-json/wp/v2/posts/${id}`)
      .then((res) => res.json())
      .then((res) => setPost(res));
  }, [id]);

  console.log(post);

  return (
    <>
      <div className="bg1 pt pb">
        <div className="container">
          <div className="post-detail">
            <h2>{post?.title.rendered}</h2>

            <img src={post?.thumbnailUrl} alt={post?.title.rendered} />

            <div dangerouslySetInnerHTML={{__html:post?.content.rendered}}></div> 
          </div>
        </div>
      </div>
      <Cta />
    </>
  );
};

export default RealizzazioneDettaglio;
